<div class="p-a-10 p-r-12 p-a-5-s p-a-5-m">
  <span class="float-right p1 m-l _linkEl">
    @if (sectionCtaLink) {
      <a class="link"
        [routerLink]="sectionCtaLink">
        {{sectionCta | translate}}
      </a>
    }
    <ng-content select="[section2cta]"></ng-content>
  </span>

  @switch (!!sectionIcon) {
    @case (true) {
      <icon-label [icon]="sectionIcon"
      [textClass]="'s1'">{{ sectionTitle | translate }}</icon-label>
    }
    @case (false) {
      <p class="s1"
      >{{sectionTitle | translate}}</p>
    }
  }


  @if (sectionSubtitle) {
    <p
    class="p1 col-12">{{sectionSubtitle | translate}}</p>
  }
  <div class="m-t-5">
    <ng-content></ng-content>
    <ng-content select="[section2content]"></ng-content>
  </div>
</div>